class VariantSelects extends HTMLElement {

  constructor() {
    super();

    // Listen for variant changes
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('click', this.onVariantClick);

    // Listen for quantity changes
    this.quantitySelector = this.closest('[data-variant-selector]').querySelector('select[name="quantity-selector"]');
    this.quantitySelector.addEventListener('change', this.onQuantityChange.bind(this));

    // Listen for upsell clicks
    const upsellButton = document.querySelector('[data-show-upsell]');
    upsellButton?.addEventListener('click', this.resetFormQuantity);
    upsellButton?.addEventListener('click', this.delayTotalPriceUpdate);
  }

  delayTotalPriceUpdate() {
    setTimeout(function(){
      this.updateTotalPrice();
    }, 250);
  }

  // When the quantity changes
  onQuantityChange() {
    this.updateFormQuantity();
    this.updateTotalPrice();
  }

  onVariantClick() {
    this.resetFormQuantity();
    document.querySelector('product-form').checkATC();
  }

  onVariantChange() {
    this.resetFormQuantity();
    this.updateOptions();
    this.updateMasterId();
    this.updateSaleBadge();
    this.toggleAddButton(true, '', false);
    let data_helper = this.closest('[data-variant-selector]').dataset.noUrl;

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      let option = this.currentVariant.option1;
      if (option.indexOf('[') > -1) {
        option = this.currentVariant.option1.split('[')[0];
      }
      this.updateVariantSwitcher(option);
      if (data_helper == 'false') {
        this.updateMedia();
        this.updateURL();
      }
      this.updateVariantInput(this);
      this.renderProductInfo();
      this.dispatchVariantChange();
    }
  }

  updateVariantSwitcher(option) {
    this.closest('[data-variant-selector]').querySelector('[data-selected-variant]').innerHTML = option;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateSaleBadge() {
    let discount = 0
    if (this.currentVariant.compare_at_price > this.currentVariant.price) {
      discount = 100 + Math.floor(this.currentVariant.price / this.currentVariant.compare_at_price * -100);
    }
    const badgeDiscount = document.querySelector('.product-media [data-sale-badge]');
    if (badgeDiscount) {

      if (discount > 0) {
        badgeDiscount.querySelector('[data-sale-badge-discount]').innerHTML = discount + '%';
        badgeDiscount.classList.remove('hidden');
      } else {
        badgeDiscount.classList.add('hidden');
      }
    } 
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent(
        'variant-change',
        {
          bubbles: true,
          variant: this.currentVariant,
          detail: {
            variant: this.currentVariant
          }
        }
      )
    );
  }

  // Update the hidden quantity input
  updateFormQuantity() {
    const quantity = this.quantitySelector.value;
    this.formQuantityInput = this.formQuantityInput || this.closest('[data-variant-selector]').querySelector('product-form input[name="quantity"]');
    this.formQuantityInput.value = quantity;
  }

  // Reset the quantity input to 1
  resetFormQuantity() {
    let quantity = this.quantitySelector.value;
    if (quantity == 0) {
      quantity = 1;
      this.quantitySelector.value = 1;
    }
    this.formQuantityInput = this.formQuantityInput || this.closest('[data-variant-selector]').querySelector('product-form input[name="quantity"]');
    this.formQuantityInput.value = quantity;
  }

  updateTotalPrice() {
    let totalPrice = 0;
    let comparePrice = 0;
    document.querySelectorAll('[data-variant-selector]').forEach(function(variant){
      let quantity = variant.querySelector('.quantity').value;
      let not_an_upsell = true;
      if (variant.classList.contains('product__variant-container--upsell')) {
        not_an_upsell = false;
      }
      if (quantity > 0 && not_an_upsell) {
        let price = variant.querySelector('[data-price]').dataset.variantPrice * quantity;
        let compare = variant.querySelector('[data-variant-compare-price]').dataset.variantComparePrice * quantity;
        if (compare == 0) {
          compare = price;
        }
        totalPrice = totalPrice + parseFloat(price);
        comparePrice = comparePrice + parseFloat(compare)
      }
    });

    let sectionId = this.dataset.section;

    if (typeof this.dataset.section === 'undefined') {
      sectionId = this.closest('[data-variant-selector]').querySelector('variant-radios').dataset.section;
    }

    // update price & compare price
    const price = document.getElementById('price-' + sectionId);

    price.querySelector('[data-regular-price]').innerHTML = Shopify.formatMoney(totalPrice);
    price.querySelector('[data-compare-price]').innerHTML = Shopify.formatMoney(comparePrice);
    if (totalPrice >= comparePrice) {
      price.querySelector('[data-regular-price]').classList.remove('price-item--regular');
      price.querySelector('[data-compare-price]').classList.add('hidden');
    } else {
      price.querySelector('[data-regular-price]').classList.add('price-item--regular');
      price.querySelector('[data-compare-price]').classList.remove('hidden');
    }

    // enable / disable add to cart button
    if (totalPrice == 0) {
      document.querySelector('[data-add-to-cart]').setAttribute('disabled', true);
    } else {
      document.querySelector('[data-add-to-cart]').removeAttribute('disabled');
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput(input) {
    const productForms = input.closest('[data-variant-selector]').querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {

        const section_id = 'shopify-section-' + this.dataset.section;
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const destination = document.getElementById(section_id);
        const source = html.getElementById(section_id);

        if (source && destination) {

          // update price
          const dest_price = this.closest('[data-variant-selector]').querySelector('[data-product-price]');
          const source_price = html.querySelector('[data-product-price]');
          dest_price.outerHTML = source_price.outerHTML;
          const compare_price = this.closest('[data-variant-selector]').querySelector('[data-variant-compare-price]').dataset.variantComparePrice;

          // hide compare price
          if (compare_price.length < 1) {
            this.closest('[data-variant-selector]').querySelector('.price__compare').classList.remove('price__compare');
            this.closest('[data-variant-selector]').querySelector('.price__sale').classList.remove('price__sale');
          }

          //rebuild quantity selector
          const quantityInput = this.closest(".product__variant-wrapper")?.querySelector('select[name="quantity-selector"]') || null;
          if (quantityInput) {
            quantityInput.innerHTML = source.querySelector('select[name="quantity-selector"]').innerHTML;
          }
        }
        
        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }

        // Update the inventory quantity hidden input
        const inventoryQtyDestination = document.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
        const inventoryQtySource = html.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
        inventoryQtyDestination.value = inventoryQtySource.value;

        // update total prices
        this.updateTotalPrice(this);
      });
  }

  /**
   * toggleAddButton
   * @param {Boolean} disable 
   * @param {String} text 
   * @param {Boolean} modifyClass 
   * @returns {void}
   */
  toggleAddButton(disable = true, text, modifyClass = true) {

    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('[data-add-to-cart-button-text]');

    if (!addButton || !addButtonText) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}

